import Offcanvas from 'bootstrap/js/dist/offcanvas';

function navbarMenu() {
    const navbarLink = document.querySelectorAll('.navbar__item > .navbar__link');
    const btnClose = document.querySelector('.btn-close');
    const items = document.querySelectorAll('.theme-section');

    let ignoreScrollEvent = false; // flag untuk mengabaikan scroll sesaat setelah klik

    // Close offcanvas pada klik navbar link (untuk mobile)
    if (window.innerWidth <= 1024) {
        navbarLink.forEach(el => {
            el.addEventListener('click', () => {
                btnClose.click();
            });
        });
    }

    // Event klik pada navbar link
    navbarLink.forEach(navItem => {
        navItem.addEventListener('click', function(e) {
            e.preventDefault(); // cegah behavior default agar kita bisa kontrol scroll

            // Hapus dan tambahkan class active
            document.querySelector('.navbar__item > .navbar__link.active')?.classList.remove('active');
            this.classList.add('active');

            // Scroll ke target
            const targetId = this.getAttribute('href').substring(1);
            const target = document.getElementById(targetId);
            if (target) {
                ignoreScrollEvent = true;
                target.scrollIntoView({ behavior: 'smooth' });

                // Hapus flag setelah delay, misalnya 1 detik
                setTimeout(() => {
                    ignoreScrollEvent = false;
                }, 1000);
            }
        });
    });

    // Event scroll
    window.addEventListener('scroll', function () {
        if (ignoreScrollEvent) return; // jangan eksekusi saat sedang transisi klik

        let currentId = '';
        let scrollTop = window.scrollY;

        items.forEach(item => {
            if (scrollTop >= item.offsetTop - 25) { // offset bisa disesuaikan
                currentId = item.getAttribute('id');
            }
        });

        // Hapus semua class active dulu
        document.querySelector('.navbar__item > .navbar__link.active')?.classList.remove('active');

        // Jika currentId ditemukan, aktifkan link yang sesuai
        if (currentId) {
            navbarLink.forEach(navItem => {
                if (navItem.getAttribute('href') === `#${currentId}`) {
                    navItem.classList.add('active');
                }
            });
        }
    });
}


document.addEventListener('DOMContentLoaded', () => {
    navbarMenu();
})